module.exports = __webpack_public_path__ + "media/games-12.dd1bd247.mp4";